import {
  Component,
  ChangeDetectionStrategy,
  OnInit,
  OnDestroy,
  inject,
} from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'et-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HomeComponent implements OnInit, OnDestroy {
  private router = inject(Router);

  showNavbar = true;
  eventsSub!: Subscription;

  ngOnInit(): void {
    this.eventsSub = this.router.events.subscribe(() => {
      this.showNavbar = this.router.url !== '/app/doc-upload/upload';
    });
  }

  ngOnDestroy(): void {
    this.eventsSub.unsubscribe();
  }
}
